import { Get, Pick, Post } from "@/api/utils";
import { IGetMeeting, IGetMeetingCode, IGetMeetingLogin } from "./index.dto";

const API_HOST = "";

export const GetAPIProgram = {
  Get_CheckExpert: API_HOST + "/api/MeetingExpert/CheckExpert", //验证嘉宾是否登录
  Get_ExpertCode: API_HOST + "/api/MeetingExpert/SengExpertCode", //发送嘉宾短信验证码
  Get_ExpertLogin: API_HOST + "/api/MeetingExpert/ExpertLogin", //嘉宾手机号登录
  Get_InitExpertPage: API_HOST + "/api/MeetingExpert/InitExpertPage", //嘉宾主页加载
  Get_ExpertNav: API_HOST + "/api/MeetingSign/InitMeetingVIPNavigation", //嘉宾个人中心接口
};
export default {
  /**
   * @title 验证嘉宾是否登录
   * @date 2021-01-12
   */
  CheckExpert(body: IGetMeeting) {
    const params = Pick(body, IGetMeeting);
    return Get({
      url: GetAPIProgram.Get_CheckExpert,
      params,
    });
  },
  /**
   * @title 发送嘉宾短信验证码
   * @date 2021-01-12
   */
  ExpertCode(body: IGetMeetingCode) {
    const params = Pick(body, IGetMeetingCode);
    return Post({
      url: GetAPIProgram.Get_ExpertCode,
      params,
    });
  },
  /**
   * @title 嘉宾手机号登录
   * @date 2021-01-12
   */
  ExpertLogin(body: IGetMeetingLogin) {
    const params = Pick(body, IGetMeetingLogin);
    return Post({
      url: GetAPIProgram.Get_ExpertLogin,
      params,
    });
  },
  /**
   * @title 嘉宾主页加载
   * @date 2020-11-24
   */
  InitExpertPage(body: IGetMeeting) {
    const params = Pick(body, IGetMeeting);
    return Get({
      url: GetAPIProgram.Get_InitExpertPage,
      params,
    });
  },
  /**
   * @title 嘉宾个人中心接口
   * @date 2020-11-24
   */
  ExpertNav(body: IGetMeeting) {
    const params = Pick(body, IGetMeeting);
    return Get({
      url: GetAPIProgram.Get_ExpertNav,
      params,
    });
  },
};
